import { swSettings } from "app/common/services/swSettings";
import type { FC } from "react";
import classNames from "classnames";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { GAPromoTooltipContentFooter } from "../Tooltip/VerifiedDataToggleInfoTooltip/GAPromoTooltipContentFooter";

interface IGAVerifiedTooltipContent {
    isActive: boolean;
    isPrivate: boolean;
    openTooltip: boolean;
    title: string;
    body: string;
    linkText: string;
    metric: string;
    /**
     * ClosePopup function gets injected into this component via the PopupHoverContainer component.
     * upon rendering this component as a popup's content, the popup automatically renders it with closePopup as a property.
     */
    closePopup?: () => void;
    onGAWizardModalOpen: () => void;
}

const GAVerifiedTooltipContent: FC<IGAVerifiedTooltipContent> = ({
    title,
    body,
    linkText,
    isActive,
    isPrivate,
    openTooltip,
    metric,
    closePopup,
    onGAWizardModalOpen,
}) => {
    const isAccountGAConnected = swSettings.components.Home.resources.IsConnectedGoogleAnalyticsAccount;
    return (
        <div className={classNames("GAVerified-tooltip-content")}>
            <div className={classNames("GAVerified-tooltip-title")}>
                <I18n>{title}</I18n>
            </div>
            <div className={classNames("GAVerified-tooltip-text")}>
                <I18n>{body}</I18n>
            </div>
            <div className="verified-data-toggle-info-tooltip-element-inner-footer">
                <div
                    className={classNames({
                        "verified-data-toggle-info-tooltip-element-inner-footer--full-width": !isAccountGAConnected,
                    })}
                >
                    <GAPromoTooltipContentFooter
                        metric={metric}
                        openTooltip={openTooltip}
                        closePopup={closePopup}
                        isAccountGAConnected={isAccountGAConnected}
                        isActive={isActive}
                        isPrivate={isPrivate}
                        linkText={linkText}
                        onGAWizardModalOpen={onGAWizardModalOpen}
                    />
                </div>
            </div>
        </div>
    );
};

export default GAVerifiedTooltipContent;
